export default {"src":"/_next/static/media/translate.c5d2c829.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};